// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__3f6hT","forgotPass":"Login_forgotPass__1t9yw"};